import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const http = axios.create({ baseURL: API });
http.interceptors.request.use((config) => {
  const token = localStorage.getItem("wt_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Workspace
export const ensureWorkspace = (payload) =>
  http.post("/gc/workspace/ensure", payload).then((r) => r.data);
export const getSummary = (wsId) =>
  http.get(`/gc/workspace/${wsId}/summary`).then((r) => r.data);

// Brand Brain
export const extractBrand = (payload) =>
  http.post("/gc/brand/extract", payload).then((r) => r.data);
export const saveBrand = (payload) =>
  http.post("/gc/brand/save", payload).then((r) => r.data);
export const approveBrand = (brandId) =>
  http.post(`/gc/brand/${brandId}/approve`).then((r) => r.data);
export const listBrandVersions = (wsId) =>
  http.get(`/gc/brand/versions?workspace_id=${wsId}`).then((r) => r.data);

// Growth Audit
export const runAudit = (payload) =>
  http.post("/gc/audit/run", payload).then((r) => r.data);
export const latestAudit = (wsId) =>
  http.get(`/gc/audit/latest?workspace_id=${wsId}`).then((r) => r.data);

// Visibility
export const generateVisPrompts = (wsId) =>
  http.post("/gc/visibility/prompts/generate", { workspace_id: wsId }).then((r) => r.data);
export const saveVisPrompts = (wsId, prompts) =>
  http.post("/gc/visibility/prompts/save", { workspace_id: wsId, prompts }).then((r) => r.data);
export const runVisPrompt = (wsId, promptId) =>
  http.post("/gc/visibility/run", { workspace_id: wsId, prompt_id: promptId }).then((r) => r.data);
export const listVisAnswers = (wsId) =>
  http.get(`/gc/visibility/answers?workspace_id=${wsId}`).then((r) => r.data);

// Creative Studio
export const createBrief = (payload) =>
  http.post("/gc/creative/brief", payload).then((r) => r.data);
export const generateConcepts = (briefId) =>
  http.post("/gc/creative/generate", { brief_id: briefId }).then((r) => r.data);
export const approveConcept = (conceptId) =>
  http.post(`/gc/creative/concepts/${conceptId}/approve`).then((r) => r.data);
export const listBriefs = (wsId) =>
  http.get(`/gc/creative/briefs?workspace_id=${wsId}`).then((r) => r.data);
export const listConcepts = (briefId) =>
  http.get(`/gc/creative/concepts?brief_id=${briefId}`).then((r) => r.data);

// Recommendations
export const listRecos = (wsId, status = null) => {
  const q = status ? `&status=${status}` : "";
  return http.get(`/gc/recommendations?workspace_id=${wsId}${q}`).then((r) => r.data);
};
export const decideReco = (recoId, decision, reason = "") =>
  http.post(`/gc/recommendations/${recoId}/decide`, { decision, reason }).then((r) => r.data);

// Audit log
export const auditLog = (wsId) =>
  http.get(`/gc/audit-log?workspace_id=${wsId}`).then((r) => r.data);
